export const planManagementDrawer_style = {};
